import { createApp } from 'vue'
import { createPinia } from 'pinia'
import {
  Aim,
  Avatar,
  Calendar,
  ChatDotRound,
  Clock,
  Connection,
  DataAnalysis,
  Document,
  DocumentChecked,
  FirstAidKit,
  FolderOpened,
  Grid,
  Histogram,
  Loading,
  OfficeBuilding,
  Picture,
  Position,
  Reading,
  Setting,
  Tickets,
  TrendCharts,
  User,
  UserFilled,
  Wallet,
  Warning,
} from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/theme-chalk/el-message-box.css'
import '@/shared/styles/index.css'
import App from './App.vue'
import router from './router'

function bootstrap() {
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)

  Object.entries({
    Aim,
    Avatar,
    Calendar,
    ChatDotRound,
    Clock,
    Connection,
    DataAnalysis,
    Document,
    DocumentChecked,
    FirstAidKit,
    FolderOpened,
    Grid,
    Histogram,
    Loading,
    OfficeBuilding,
    Picture,
    Position,
    Reading,
    Setting,
    Tickets,
    TrendCharts,
    User,
    UserFilled,
    Wallet,
    Warning,
  }).forEach(([name, component]) => {
    app.component(name, component)
  })

  app.mount('#app')
}

bootstrap()
